"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clinicDummy = exports.contactDummy = exports.schoolDummy = void 0;
exports.schoolDummy = {
    name: 'OBS de Tweemaster',
    street: 'Verlenge Nieuwstraat',
    postal_code: '3011GM',
    city: 'Rotterdam',
    email: 'info@obsdetweemaster.nl',
    phone: '010 450 0012',
};
exports.contactDummy = {
    group: 'Groep 7-8',
    students: '39 leerlingen',
    name: 'Willem van Weversen',
    email: 'willem@obsdetweemaster.nl',
    phone: '+31 6 435 724 03',
};
exports.clinicDummy = {
    name: 'Atletiek',
    sport: 'Atletiek',
    type: 'Doorstroom clinic',
    cancelled: false,
    date: '1 augustus 2022',
    time: '10:00 - 12:00',
    street: 'Coloniastraat 5',
    postal_code: '3024 TA',
};
